import { defineMessages } from 'react-intl';

const messages = defineMessages({
  templatesSectionTitle: {
    defaultMessage: 'Customer Communication',
    description: 'Order details shipment templates and communication settings section header',
    id: 'WfgYUC',
  },
  sectionAriaLabel: {
    defaultMessage: 'Customer Communication expander section',
    description: 'Aria label for the expandable customer communication section',
    id: 'nKP99t',
  },
});

export default messages;
